module.exports = __webpack_public_path__ + "static/media/SVGChat.8b8a922d.svg";